import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgIcon } from '@ng-icons/core';
import { DocumentEventService } from '../../services/document-event.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [NgIcon],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  readonly isOpen = input(false);
  readonly title = input('Confirm Action');
  readonly message = input('Are you sure you want to proceed?');
  readonly confirmText = input('Confirm');
  readonly cancelText = input('Cancel');
  readonly variant = input<'danger' | 'warning' | 'info'>('danger');

  readonly confirmed = output<void>();
  readonly cancelled = output<void>();

  constructor() {
    inject(DocumentEventService)
      .escape$.pipe(takeUntilDestroyed())
      .subscribe(() => {
        if (this.isOpen()) this.onCancel();
      });
  }

  onConfirm(): void {
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onCancel();
    }
  }
}
